
type Params = {[key: string]: any} | string

const logger = function(type: string)  {
  return {
    error(params: Params) {
      if (typeof params !== 'object') {
        console.error(`${JSON.stringify({
          title: `${type}-err`,
          string: params,
        })}`)
        return
      }
      console.error(`${JSON.stringify({
        title: `${type}-err`,
        ...params
      })}`)
    },
    log(params: Params) {
      if (typeof params !== 'object') {
        console.log(`${JSON.stringify({
          title: `${type}-log`,
          string: params,
        })}`)
        return
      }
      console.log(`${JSON.stringify({
        title: `${type}-log`,
        ...params
      })}`)
    }
  }
}
export default logger
